// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2TTvX","select":"Header_select__2kr3T","clinic":"Header_clinic__1-qnZ"};